module.exports = __webpack_public_path__ + "img/jjptadmin-qrcode.5104db3d.png";